
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","clip-path":"url(#clip0_25476_41271)"}},[_c('path',{attrs:{"d":"M21.927 22.048a1.715 1.715 0 01-1.714 1.714H4.785a1.714 1.714 0 01-1.715-1.714V3.19a1.714 1.714 0 011.715-1.714h8.571l8.571 8.572v12z"}}),_c('path',{attrs:{"d":"M8.21 15.19l2.572 1.715 4.286-6.857"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_25476_41271"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .62)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    